import React from 'react'

export default function Ordercancel() {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <h1 className="text-3xl font-bold text-blue-900 mb-8 text-center">Order Cancellation and Return policy</h1>
      
      {/* Single section containing all content */}
      <div className="bg-white p-8 rounded-lg  border-gray-200 space-y-10 py-[35px] lg:px-[7%]">
        {/* Cancellation Policy */}
        <div>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4 text-left">1. Cancellation policy</h2>
          <p className="text-gray-700 mb-6 leading-relaxed">
            You have up to 24 hours to cancel your order. Because orders are forwarded to our warehouse as soon as confirmation is complete, cancellation requests must be made within this window. To see if your order is still eligible, log in to your account and go to My Account. If the order you wish to cancel shows a Cancel Order button, simply click it to cancel. If processing has already begun, cancellation is no longer possible—but you may return the unopened package for a refund once you receive it.
          </p>
        </div>

        {/* Processing time for Cancellation Request */}
        <div className="border-t border-gray-200 pt-8">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4 text-left">2. Processing time for Cancellation Request</h2>
          <ul className="list-disc pl-5 space-y-2 text-gray-700">
            <li>Once you click the "cancel order" button, your order will be cancelled immediately.</li>
          </ul>
        </div>

        {/* Return Policy */}
        <div className="border-t border-gray-200 pt-8">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4 text-left">3. Return Policy</h2>
          <ul className="list-disc pl-5 space-y-3 text-gray-700">
            <li>Returns must be initiated within 30 days of delivery.</li>
            <li>A valid RMA (Return Merchandise Authorization) number is required. Returns submitted without one will not be processed.</li>
            <li>Parts must be unused, undamaged, and in their original manufacturer packaging to qualify for reimbursement.</li>
            <li>Items that have been installed or otherwise tampered with are not eligible for return.</li>
            <li>Prepaid return shipping labels are provided only for products that are Damaged on Arrival, defective, or shipped in error. We may request photos of the shipment box and the parts.</li>
            <li>Apparel returns must be in original, unworn, and unused condition, with all tags and labels attached, and free from odors, stains, or signs of wear. We do not offer direct exchanges—please return the original item and place a new order for the desired size or color.</li>
          </ul>
        </div>

        {/* Fee and Charges for Return */}
        <div className="border-t border-gray-200 pt-8">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4 text-left">4. Fee and Charges for Return</h2>
          <p className="text-gray-700 mb-4 leading-relaxed">
            Customers are responsible for return shipping costs for any return not caused by our error, and a 15% restocking fee will be deducted from your refund. VAP will only provide a prepaid return shipping label—and cover that cost—after reviewing the case and confirming the return is due to our error. If you refuse delivery or a package is returned because of an invalid address, the shipping charges for both the original delivery and the return will be deducted from your refund.          </p>
       
        </div>

        {/* Refund for return cancellation */}
        <div className="border-t border-gray-200 pt-8">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4  text-left">5. Refund for return cancellation</h2>
          <p className="text-gray-700 mb-6 leading-relaxed">
            For cancelled orders, refunds will be issued to your original payment method within 2–7 business days. For returned products, we will process refunds within 7–10 business days to the same payment method. Please note that, due to unforeseen circumstances during COVID, processing may occasionally take longer.
          </p>
        </div>

        {/* Modes of refund after cancellation */}
        <div className="border-t border-gray-200 pt-8">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4 text-left">6. Modes of refund after cancellation</h2>
          <p className="text-gray-700 leading-relaxed">
            Refunds are typically processed using the original payment method (e.g., PayPal or credit card).
          </p>
        </div>

        {/* What if refund gets delayed */}
        <div className="border-t border-gray-200 pt-8">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4 text-left">7. What if refund gets delayed</h2>
          <p className="text-gray-700 mb-4 leading-relaxed">
          You will receive a confirmation email once your refund has been issued. If you do not receive this email, please contact us immediately via live chat or at *****************. If, after receiving our confirmation, your refund has not appeared in your account, please reach out to your bank—some financial institutions require additional processing time. We’re happy to provide any information your bank may need to complete your refund.
          </p>
          
        </div>

        {/* Items Return Condition */}
        <div className="border-t border-gray-200 pt-8">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4 text-left">8. Items Return Condition</h2>
          <p className="text-gray-700 mb-4 leading-relaxed">
            Unused, unopened items may be returned within 30 days of delivery. Electronic components—including lights, bulbs, ignition parts, relays, sensors, and switches—are non-refundable if their packaging has been opened or installation attempted.All returns must include parts in their original manufacturer packaging to qualify for reimbursement.
          </p>
          <p className="text-gray-700 leading-relaxed">
            Kits must be returned intact—individual components cannot be returned separately.
          </p>
        </div>

        {/* Item exchange policy */}
        <div className="border-t border-gray-200 pt-8">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4 text-left">9. Item exchange policy</h2>
          <p className="text-gray-700 leading-relaxed">
            Currently, we do not offer exchanges. Please return your item and place a new order for the replacement.
          </p>
        </div>

        {/* Steps to return an order */}
        <div className="border-t border-gray-200 pt-8">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4 text-left">10 .Steps to return an order</h2>
          <ul className="list-disc pl-5 space-y-4 text-gray-700">
            <li>
              <strong>Log In</strong>
              <p className="mt-1 text-gray-600">Go to My Account and sign in with your email and password.</p>
            </li>
            <li>
              <strong>Select Your Order</strong>
              <p className="mt-1 text-gray-600">Under Orders, locate and open the order you wish to return.</p>
            </li>
            <li>
              <strong>Initiate Return</strong>
              <p className="mt-1 text-gray-600">Click the Take Actions dropdown and choose Return Order.</p>
            </li>
            <li>
              <strong>Provide Return Details</strong>
              <p className="mt-1 text-gray-600">On the return form, select each item to return, specify the quantity, choose a reason, and add any comments. Click Continue.</p>
            </li>
            <li>
              <strong>Confirm Request</strong>
              <p className="mt-1 text-gray-600">You'll see a confirmation page—click Next.</p>
            </li>
            <li>
              <strong>Print RMA Receipt</strong>
              <p className="mt-1 text-gray-600">Click Print RMA Receipt. This document must accompany your return.</p>
            </li>
            <li>
              <strong>Prepare the Package</strong>
              <p className="mt-1 text-gray-600">Pack the part in its original manufacturer's box (no markings, extra tape, or damage), then place that inside a sturdy shipping box. Remove any old shipping labels. Attach the RMA receipt to the outside of the box.</p>
            </li>
            <li>
              <strong>Ship Your Return</strong>
             
              <p className="mt-1 text-gray-600">Send the package to the address listed on the RMA receipt via your preferred carrier, or drop it off at the location specified. If you have questions about drop-off hours, contact us via live chat.</p>
            </li>

          </ul>
          
          <div className="mt-2 p-4 bg-gray-50 rounded-lg">
            <p className="text-gray-700">
              <strong>For Guest (Unregistered) Customers:</strong> Please contact our customer service team for assistance with returns.
            </p>
          </div>
        </div>

        {/* Return Address Information */}
        <div className=" border-gray-200 pt-6">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4 text-left">11. Return Address Information</h2>
          <div className="mb-6">
            <div className="bg-gray-50 p-4 rounded-lg">
              <p className="text-gray-700 mb-2">
                <strong>Return Address:</strong><br />
                10509 135a St, Surrey, BC V3T 4C9
              </p>
              <p className="text-gray-700">
                <strong>Phone #:</strong> (604) 581-5464
              </p>
              <p className="text-gray-700 mb-2">
                <strong>UserName:</strong><br />
                vapautoparts@gmail.com
              </p>
              <p className="text-gray-700">
                <strong>Pswd:</strong> Vap9324$
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>  
  )
}